import React from 'react'
import { Modal } from 'reactstrap'

type Props = {
    isOpen: boolean
}

function CustomLoader({ isOpen }: Props) {
    return (
        <Modal centered isOpen={isOpen} size='sm' className='loader-modal'>
            <div className="loader-text"> </div>
        </Modal>
    )
}

export default CustomLoader